
import { inject } from '@angular/core';
import { PermissionService } from '@core/services/permission.service';
import { Permission } from '../enums/permission.enum';



export const CHECK_PERMISSIONS = () => {
  // Define your permission checks here
  const permissionService = inject(PermissionService);
  return {
    isAuthenticated(): boolean {
        return permissionService.isAuthenticated();
    },

    canReadProfile(): boolean {
        return permissionService.hasPermission(Permission.UsersRead);
    },

    canManageUsers(): boolean {
        return permissionService.hasPermission(Permission.UsersManagementRead);
    },

    canReadEmployees(): boolean {
        return permissionService.hasPermission(Permission.EmployeesRead);
    },

    canReadClients(): boolean {
        return permissionService.hasPermission(Permission.ClientsRead);
    },
    canReadAffiliates(): boolean {
        return permissionService.hasPermission(Permission.AffiliatesRead);
    },
    canReadInterventions(): boolean {
        return permissionService.hasPermission(Permission.InterventionsRead);
    },
    canImportEmployees(): boolean {
        return permissionService.hasPermission(Permission.EmployeesCreate);
    }, 
    canReadCompanies(): boolean {
        return permissionService.hasPermission(Permission.CompaniesRead);
    }, 
    canAccessHangfire(): boolean {
        return (
        permissionService.hasPermission(Permission.HangfireRead) ||
        permissionService.hasPermission(Permission.UsersManagementRead) ||
        permissionService.hasPermission(Permission.Admin)
        );
    }
  };
};